import { useEffect, useState, useContext, useCallback } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/AuthContext";
import { FaUsers, FaKey, FaToggleOn, FaToggleOff } from "react-icons/fa";
import AdminLayout from "./Layout/AdminLayout";


export default function AdminUsersPage() {
  const { user: currentUser } = useContext(AuthContext);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [plan, setPlan] = useState("");
  const [verified, setVerified] = useState("");

  const isValidObjectId = (id) => /^[0-9a-fA-F]{24}$/.test(id);

 // inside your component
 const fetchUsers = useCallback(async () => {
   setLoading(true);
   try {
     const res = await api.get("/admin/users", {
       params: { page, search, plan, verified },
     });
     setUsers(res.data.data || []);
     setTotalPages(res.data.pagination?.pages || 1);
   } catch (err) {
     console.error("Failed to fetch users", err);
   } finally {
     setLoading(false);
   }
 }, [page, search, plan, verified]); // dependencies used inside fetchUsers
 
 useEffect(() => {
   if (!currentUser || !["admin", "super_admin"].includes(currentUser.role)) return;
   fetchUsers();
 }, [currentUser, fetchUsers]); // now safe

//   const updatePlan = async (userId, newPlan) => {
//     if (!isValidObjectId(userId)) return;
//     await api.patch(`/admin/users/${userId}/plan`, { plan: newPlan });
//     fetchUsers();
//   };

  const toggleStatus = async (userId, current) => {
    if (!isValidObjectId(userId)) return;
    await api.patch(`/admin/users/${userId}/status`, {
      isActive: !current,
    });
    fetchUsers();
  };

  const resetApiKey = async (userId) => {
    if (!isValidObjectId(userId)) return;
    const res = await api.post(`/admin/users/${userId}/reset-api-key`);
    alert(`New API Key:\n${res.data.apiKey}`);
  };

  return (
    <AdminLayout>
    <div className="card shadow-sm border-0 mt-5">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="fw-bold mb-0">
            <FaUsers className="me-2 text-primary" />
            User Management
          </h4>
        </div>

        {/* Filters */}
        <div className="row g-3 mb-4">
          <div className="col-md-4">
            <input
              className="form-control"
              placeholder="Search email or username"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="col-md-4">
            <select
              className="form-select"
              value={plan}
              onChange={(e) => setPlan(e.target.value)}
            >
              <option value="">All Plans</option>
              <option value="free">Free</option>
              <option value="basic">Basic</option>
              <option value="standard">Standard</option>
              <option value="premium">Premium</option>
              <option value="dedicated">Dedicated</option>
            </select>
          </div>

          <div className="col-md-4">
            <select
              className="form-select"
              value={verified}
              onChange={(e) => setVerified(e.target.value)}
            >
              <option value="">All Users</option>
              <option value="true">Verified</option>
              <option value="false">Unverified</option>
            </select>
          </div>
        </div>

        {/* Table */}
        {loading ? (
          <p className="text-muted">Loading users…</p>
        ) : users.length === 0 ? (
          <p className="text-muted">No users found.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Plan</th>
                  <th>Verified</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u._id}>
                    <td className="fw-semibold">{u.fullName}</td>
                    <td>{u.email}</td>
                    <td>
                        {u.plan}
                      {/* <select
                        className="form-select form-select-sm"
                        value={u.plan}
                        onChange={(e) =>
                          updatePlan(u._id, e.target.value)
                        }
                      >
                        <option value="free">Free</option>
                        <option value="basic">Basic</option>
                        <option value="standard">Standard</option>
                        <option value="premium">Premium</option>
                        <option value="dedicated">Dedicated</option>
                      </select> */}
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          u.isVerified
                            ? "bg-success"
                            : "bg-secondary"
                        }`}
                      >
                        {u.isVerified ? "Yes" : "No"}
                      </span>
                    </td>
                    <td className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-outline-warning"
                        onClick={() =>
                          toggleStatus(u._id, u.isActive)
                        }
                      >
                        {u.isActive ? (
                          <FaToggleOn />
                        ) : (
                          <FaToggleOff />
                        )}
                      </button>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => resetApiKey(u._id)}
                      >
                        <FaKey />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Prev
          </button>

          <small className="text-muted">
            Page {page} of {totalPages}
          </small>

          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={page === totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
    </AdminLayout>
  );
}